export default __webpack_public_path__ + "static/media/format-underline.88bc413d.svg";